<template>
  <Card :bordered="false" dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_day') }}</p>
    </div>
    <a href="#" slot="extra">
      <Button size="small" type="dashed" class="extra-btn" @click="goTo">
        {{ $t('common.more') }}
        <Icon type="ios-arrow-forward" />
      </Button>
      <slot name="extra"></slot>
    </a>
    <div>
      <hot :useScene="scene" />
    </div>
  </Card>
</template>

<script>
import hot from '../../../components/hot-chart.vue';
export default {
  data() {
    return {
      aiList: [],
      swiperValue: 0,
      isLoading: true,
      originData: null,
      scene: 'NORMAL',
    };
  },
  components: {
    hot,
  },
  mounted() {},
  methods: {
    goTo() {
      this.$system.goRouter({
        router: {
          system: ccconstants.SYSTEM_NOS.Web_People_Counting,
          url: `/hotspotDate`,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
</style>
